<template>
  <div class="pb-0 mb-0">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">ASIGNACION TOTAL POR SEDE.</h4>

    <v-row dense class="ml-2">
      <v-col cols="12" sm="4" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Seleccione la fecha:"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field v-model.number="xcuota" label="Cuota:" type="number" dense outlined />
      </v-col>
      <v-col cols="12" sm="3" md="4">
        <v-switch
          v-model="only_cuota"
          :label="only_cuota ? 'Mostrar desde cuota seleccionada' : 'Mostrar solo cuota seleccionada'"
          :disabled="loading"
          dense
          hide-details
          title="Mostrar datos de la cuota seleccionada."
          class="mb-4"></v-switch>
      </v-col>
      <v-col cols="12" sm="2" md="3">
        <v-btn class="blue darken-2" dark tile :disabled="loading" @click="obtenerasignaciones()">Calcular</v-btn>
      </v-col>
    </v-row>
    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <v-progress-linear indeterminate v-if="loading" class="mt-2" />
    <p class="mb-0" v-if="xname">
      <b>Asignacion de la unidad: {{ xname }}</b>
    </p>

    <div v-if="datos.length > 0" class="text-right">
      <v-btn dense tile color="purple" outlined dark class="mb-1" small @click="tableToExcel('table2')">
        <v-icon left>mdi-download</v-icon> Descargar excel
      </v-btn>
    </div>

    <div class="table-responsive">
      <table class="ztable table-hover" ref="table2">
        <thead>
          <tr class="white--text">
            <template v-for="(r, ind) in rotulos">
              <th v-if="r != 'idprograma'" :key="ind" :class="r == 'nombre' ? 'fixedheader' : 'green darken-4'">
                {{ getrotuloparse(r) }}
              </th>
            </template>
          </tr>
        </thead>

        <tbody>
          <template v-for="(sede, ind) in datos">
            <template>
              <tr :key="ind">
                <template v-for="(r, ind) in rotulos">
                  <td v-if="r != 'idprograma'" :key="ind">{{ getfromkey(sede, r) }}</td>
                </template>
              </tr>
            </template>
          </template>

          <tr>
            <template v-for="(t, ind) in Object.keys(totales)">
              <td v-if="t != 'idprograma'" :key="ind" class="xrowtotal">{{ getfromkey(totales, t) }}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>

    <toexcel ref="toexcel" />
  </div>
</template>

<style>
  @import url('./stilotablas.css');
</style>

<script>
  import xaxios from '@/xaxios';
  import toexcel from '../proyecciones/toexcel';

  export default {
    data() {
      return {
        gestiones: [2024,2023, 2022, 2021, 2020, 2019, 2018],
        tiposasignacion: [
          { id: 1, text: 'Asignacion' },
          { id: 2, text: 'Inscritos' },
        ],
        loadinggestion: false,
        loadingmes: false,
        filtros: {
          gestion: null,
          mes: null,
          tipoasignacion: null,
          unidad: null,
        },
        buscar: '',
        datos: [],
        rotulos: [],
        totales: {},
        loading: false,
        msg: '',
        loadingunidades: false,
        omit_filtro: false,

        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu2: false,
        xcuota: 1,
        only_cuota: true,
        unidades: [],
        xname: '',
      };
    },
    watch: {
      '$store.state.CARGO.sede': function () {
        this.obtenerasignaciones();
      },
      '$store.state.convenio': function () {
        if (this.$store.state.convenio) {
          this.obtenerasignaciones();
        }
      },
    },
    components: { toexcel },
    methods: {
      tableToExcel(table) {
        if (!table.nodeType) table = this.$refs[table];
        this.$refs.toexcel.tableToExcel(table, 'asig-total-sedes.xls');
      },
      dataloaded() {
        this.loading = false;
      },
      obtenerasignaciones() {
        if (this.loading) return;
        this.loading = true;

        this.getfromserver();
      },
      getrotuloparse(key) {
        if (key == 'xtotal') return 'TOTAL';
        else if (key == 'nombre_compuesto') return 'Programas';
        let fs = key.split('_');
        return fs.join(' ');
      },
      getfromkey(obj, key) {
        return this.parsecomas(obj[key]);
      },
      parsecomas(str) {
        if (isNaN(str)) return str;
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      getfromserver() {
        let convenio = 0;
        if (this.$store.state.convenio && !this.omit_filtro) convenio = this.$store.state.convenio.id;
        let p = `sede_id=${this.$store.state.CARGO.idsede}&universidad_id=${convenio}`;
        let urla = `${process.env.VUE_APP_API_REST}/api/v2/esam/asignacion/total/sedes?nro_cuota=${this.xcuota}&fecha=${this.date} 23:59&desde=${this.only_cuota}&${p}`;
        const promise2 = xaxios.get(urla);
        let vue = this;
        this.datos = [];
        this.rotulos = [];

        Promise.all([promise2])
          .then(function (values) {
            let data1 = values[0].data;
            let xdatos = data1.data;
            vue.rotulos = window.Object.keys(data1.data[0]);
            vue.totales = JSON.parse(JSON.stringify(data1.data[0]));
            window.Object.keys(vue.totales).forEach((x) => {
              vue.totales[x] = 0;
            });

            let totaltotal = 0;
            xdatos.forEach((x) => {
              let keys = window.Object.keys(x);
              let xtotal = 0;
              keys.forEach((k) => {
                if (vue.totales[k] == null) vue.totales[k] = 0;
                vue.totales[k] += x[k];
                if (k != 'idprograma' && k != 'codigo' && !isNaN(x[k])) {
                  xtotal += x[k];
                  totaltotal += x[k];
                }
              });
              x.xtotal = xtotal;
            });

            vue.rotulos.push('xtotal');
            vue.totales.nombre_compuesto = 'TOTAL';
            vue.totales.codigo = '-';
            vue.totales.xtotal = totaltotal;
            vue.datos = xdatos;
            window.console.log(vue.datos, totaltotal);
            vue.loading = false;
          })
          .catch((e) => {
            window.console.error(e);
            vue.loading = false;
          });
      },
    },
    mounted() {
      let id_unidad = this.$route.query.id_unidad;
      if (id_unidad) {
        this.xname = this.$route.query.name;
        this.filtros.unidad = { text: this.xname, id: id_unidad };
        this.obtenerasignaciones();
      }
    },
  };
</script>
